namespace $ {

	/**
	 * Gap in CSS
	 * @see https://page.hyoo.ru/#!=msdb74_bm7nsq
	 */
	export let $mol_gap = $mol_style_prop(
		'mol_gap',
		[
			'block',
			'text',
			'round',
			'space',
			'blur',
		]
	)

}
